// Module
var code = "<div class=\"panel panel-default\"> <div class=\"panel-heading\"> <h3 class=\"panel-title\">Contacts</h3> </div> <div style=\"height:250px;overflow:auto\"> <contact-list-table customer-guid=\"$ctrl.customerGuid\"> </contact-list-table></div> </div> ";
// Exports
module.exports = code;